
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.66 1A1.34 1.34 0 0114 2.34v7.83c0 .266-.106.522-.297.713l-5.607 5.606-.082-.063a1.531 1.531 0 01-.427-.501l-.037-.07L8.717 10H2a.996.996 0 01-.705-.295A.996.996 0 011 9V7.92l2.727-6.481C3.912 1.165 4.223 1 4.56 1zM19 1v9h-1V1h1z","stroke":"#CCC","stroke-width":"2","fill":"none"}})])
          )
        }
      }
    